"use client";

import { useTranslations } from "next-intl";
import { openConsentPreferences } from "@/lib/cookieConsent";

/** Rouvre la carte de consentement, depuis une page serveur. */
export default function ManageCookiesButton({ className = "" }) {
    const t = useTranslations("layout");

    return (
        <button
            type="button"
            onClick={openConsentPreferences}
            className={`font-medium underline underline-offset-2 ${className}`}
        >
            {t("Footer_cookies")}
        </button>
    );
}
